var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blw-illustration"},[_c('v-img',{attrs:{"src":_vm.imageSource,"width":_vm.size,"max-width":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }